module.exports = __webpack_public_path__ + "static/media/gmn-qc-dept.70322090.png";